import * as Styled from './Dropdown.styled';
import { useCommonAuthProvider } from '@modules/auth/providers/CommonAuthProvider/CommonAuthProvider';
import { LogoutIcon } from 'app/_components/Icons/LogoutIcon';
import { useOrganization } from 'app/_providers/Organization';
import { useUser } from 'app/_providers/User';

import { CopyOutlined } from '@ant-design/icons';
import { Toast } from '@capra/core';
import React from 'react';

type Props = Readonly<{
  closePopover: () => unknown;
  hideProfile?: boolean;
}>;

export const DropdownContent: React.FC<Props> = ({ closePopover, hideProfile }) => {
  const user = useUser();
  const { organizationId } = useOrganization();
  const { getAccessToken } = useCommonAuthProvider();
  const showCopyToken = process.env.ENABLE_ACCESS_TOKEN_COPY === 'true';

  const handleCopyToken = async (e: React.MouseEvent) => {
    e.preventDefault();

    try {
      const token = await getAccessToken();

      if (!token) {
        Toast.error('No access token available', { position: 'bottom-right' });
      } else {
        await navigator.clipboard.writeText(token);
        Toast.success('Access token copied to clipboard', { position: 'bottom-right' });
      }
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : '';
      Toast.error(`Failed to copy access token${errorMessage && `: ${errorMessage}`}`, { position: 'bottom-right' });
    }
    closePopover();
  };

  return (
    <Styled.DropdownWrap>
      <Styled.BoldedDropdownSection>{user.email}</Styled.BoldedDropdownSection>

      <Styled.DropdownDivider />

      {!hideProfile &&
        <>
          <Styled.DropdownSection>
            <Styled.DropdownLink
              href={{
                pathname: `/organizations/${organizationId}/profile`,
              }}
              onClick={closePopover}
            >
              My Profile
            </Styled.DropdownLink>
          </Styled.DropdownSection>
          <Styled.DropdownDivider />
        </>}

      {showCopyToken &&
        <>
          <Styled.DropdownSection>
            <Styled.DropdownLink href='#' onClick={handleCopyToken}>
              <CopyOutlined style={{ fontSize: 16 }} />
              Copy Access Token
            </Styled.DropdownLink>
          </Styled.DropdownSection>
          <Styled.DropdownDivider />
        </>}

      <Styled.DropdownSection>
        <Styled.DropdownLink href='/logout'>
          <LogoutIcon
            width={16}
            height={16}
          />
          Log out
        </Styled.DropdownLink>
      </Styled.DropdownSection>
    </Styled.DropdownWrap>
  );
};
